/**
 * P1 consolidación is_freelance: los autónomos SOCIETARIOS pasan a
 * `isFreelance=true` manteniendo su `companyId` real. El freelance PURO
 * (sin empresa) es la única tipología que:
 *  - NO debe pedir la config de empresa (su JWT trae un companyId placeholder).
 *  - Ve la vista individual (home individual, tabs de autónomo).
 * El societario conserva la experiencia de empleado B2B.
 */
export const isPureFreelanceUser = (
	user?: { isFreelance?: boolean; companyId?: string } | null
): boolean => !!user?.isFreelance && !user?.companyId;
